export default __webpack_public_path__ + "static/media/Srikalahasthi.8f24fb6e.webp";